export enum AuthorityMatrix {
  CONFIGURATION_MATRIX_PERMISSIONS_MANAGE_GROUP = '6.2.7',
  CONFIGURATION_MATRIX_DELETE_USER_FROM_GROUP = '6.2.6',
  CONFIGURATION_MATRIX_ADD_USER_TO_GROUP = '6.2.5',
  CONFIGURATION_MATRIX_MANAGE_USER_GROUPS = '6.2.4',
  CONFIGURATION_MATRIX_DELETE_USER_GROUP = '6.2.3',
  CONFIGURATION_MATRIX_GROUPS_ADD_USER = '6.2.2',
  CONFIGURATION_MATRIX_GROUPS_VIEW_USER = '6.2.1',
  CONFIGURATION_MATRIX_GROUPS_USER = '6.2',
  CONFIGURATION_MATRIX_CHANGE_USER_PASSWORD = '6.1',
  CONFIGURATION_MATRIX_SETTINGS = '6.',
  CONFIGURATION_MATRIX_SETTINGS_ADD_CUSTOMER = '6.6.1',
  CONFIGURATION_MATRIX_SETTINGS_EDIT_CUSTOMER = '6.6.2',
  CONFIGURATION_MATRIX_SETTINGS_VIEW_CUSTOMER = '6.6.3',
}
